/** Labeled wrapper for a single form control with an optional error message.
 *  Used by the auth forms (Login / Register). */
export function FormField({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-foreground">{label}</span>
      <div className="mt-1">{children}</div>
      {error ? <span className="text-xs text-destructive mt-1 inline-block">{error}</span> : null}
    </label>
  );
}
